import store from '@/store'
import { TASK_GET_NEXT, TASK_GET, AGENT_AUTH_TOKEN_KEY } from '@/store/types'

export default {
  path: '/agent',
  name: 'agent_base',
  component: () => import('@/views/agent/Base.vue'),
  children: [
    {
      path: 'login',
      name: 'agent_login',
      component: () => import('@/views/agent/Login.vue'),
    },
    {
      path: 'task',
      name: 'agent_task',
      component: () => import('@/views/agent/Task.vue'),
      beforeEnter: async (to, _, next) => {
        // When Admin is opening Agent UI for outbound call task
        if (to.query.agent_token) {
          localStorage.setItem(AGENT_AUTH_TOKEN_KEY, to.query.agent_token)
        }

        if (to.query.task_id) {
          await store.dispatch(TASK_GET, { id: to.query.task_id })
        }

        if (!store.getters.getCurrentTask) {
          await store.dispatch(TASK_GET_NEXT)
        }

        if (!store.getters.getCurrentTask) {
          next({ name: 'agent_no_task' })
        } else {
          next()
        }
      },
      meta: {
        requireAuth: true,
      },
    },
    {
      path: 'no_task',
      name: 'agent_no_task',
      component: () => import('@/views/agent/NoTask.vue'),
      meta: {
        requireAuth: true,
      },
    },
  ],
}
